const IRIS = Object.freeze({
  book: "/books/",
  currency: "/currencies/",
  localBook: "/local_books/",
  bookList: "/book_lists/",
  order: "/orders/",
  event: "/events/",
  school: "/schools/",
  safaricomMpesaRequests: "/safaricom_mpesa_requests/",
  momoMtnPayments: "/momo_mtn_payments/", 
  author: "/authors/",
  authorRole: "/author_roles/",
  bookFormat: "/book_formats/",
  featuredBook: "/featured_books/",
  publisher: "/publishers/",
});

export default IRIS;

export function removeIriId(id) {
  return id.split("/").pop();
}

export function createIri(type, id) {
  if (!type || !id) return '';
  
  // If id already contains a slash, assume it's already an IRI and return it as is
  if (typeof id === 'string' && id.includes('/')) {
    return id;
  }
  
  // Normalize the type by removing leading/trailing slashes
  const normalizedType = type.replace(/^\/|\/$/g, '');
  // Find the path from IRIS matching either "/<normalizedType>/" or "/<normalizedType>s/"
  const iriPath = Object.values(IRIS).find(path => 
    path === `/${normalizedType}/` || path === `/${normalizedType}s/`
  );
  
  return iriPath ? `${iriPath}${id}` : `/${normalizedType}/${id}`;
}
